import { useState } from "react";

const brands = ["ReportMaster", "Self-Branded", "Unbranded"];

export default function StepBranding({ onNext, onBack, formData }) {
  const [branding, setBranding] = useState(formData.branding || "");

  return (
    <div>
      <h2 className="text-xl font-semibold mb-2">Choose Report Branding</h2>
      <select
        className="w-full p-2 border rounded mb-4"
        value={branding}
        onChange={e => setBranding(e.target.value)}
      >
        <option value="">Select branding...</option>
        {brands.map(b => (
          <option key={b} value={b}>{b}</option>
        ))}
      </select>
      <div className="flex gap-2 mt-4">
        <button className="btn btn-secondary" onClick={onBack}>Back</button>
        <button className="btn btn-primary" disabled={!branding} onClick={() => onNext({ branding })}>
          Next
        </button>
      </div>
    </div>
  );
}